var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('a-col',{attrs:{"span":3}},[_c('Menu')],1),_c('a-col',{attrs:{"span":21}},[_c('Header')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }